import whyEmiSaathiImage from "../assets/why-emisaathi.png";
import "./container.css";
import "./WhyChooseUs.css";

const TOP_FEATURES = [
  {
    title: "No Collateral Required",
    lines: [
      "Consolidate your debts without pledging",
      "assets. Simple, unsecured financing",
      "designed for real-life needs.",
    ],
  },
  {
    title: "Predictable Monthly Outflow",
    lines: [
      "Fixed interest rates ensure stable EMIs,",
      "helping you plan your finances with",
      "confidence.",
    ],
  },
  {
    title: "Quick Approvals",
    lines: [
      "Get faster decisions with our smart digital",
      "process reduce delays and avoid additional",
      "penalties on existing dues.",
    ],
  },
];

const BOTTOM_FEATURES = [
  {
    title: "Add a Co-Applicant Easily",
    lines: [
      "Apply with a co-applicant to unlock better",
      "terms and higher approval chances.",
    ],
  },
  {
    title: "Flexible Repayment Options",
    lines: [
      "Choose repayment tenures and EMI",
      "structures that align with your monthly cash",
      "flow.",
    ],
  },
];

const Card = ({ title, lines }: { title: string; lines: string[] }) => (
  <div className="why-choose-card">
    <h3
      className="why-choose-card-title"
      style={{ color: "#333", fontStyle: "normal", fontWeight: 500, fontFamily: "'Plus Jakarta Sans'" }}
    >
      {title}
    </h3>
    <p
      className="why-choose-card-desc"
      style={{ color: "#5D5D5D", fontStyle: "normal", fontWeight: 400, fontFamily: "'Plus Jakarta Sans'" }}
    >
      {lines.map((line, index) => (
        <span key={line}>
          {line}
          {index < lines.length - 1 && <br />}
        </span>
      ))}
    </p>
  </div>
);

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us w-full">
      <div className="container-8xl">
        <h2
          className="why-choose-heading"
          style={{ fontStyle: "normal", fontWeight: 500, fontFamily: "Inter" }}
        >
          <span style={{ color: "#333" }}>Why Choose </span>
          <span style={{ color: "#032799" }}>EMI</span>{" "}
          <span style={{ color: "#F94C09" }}>Saathi</span>
          <span style={{ color: "#333" }}> For </span>
          <span style={{ color: "#032799" }}>Debt Consolidation</span>
        </h2>

        <div className="why-choose-cards" style={{ marginTop: 32 }}>
          {TOP_FEATURES.map((feature) => (
            <Card key={feature.title} {...feature} />
          ))}
        </div>

        <div className="why-choose-cards-bottom" style={{ marginTop: 20 }}>
          {BOTTOM_FEATURES.map((feature) => (
            <Card key={feature.title} {...feature} />
          ))}
        </div>

        <img
          src={whyEmiSaathiImage}
          alt="EMI Saathi debt consolidation loan application"
          className="why-choose-image"
        />
      </div>
    </section>
  );
};

export default WhyChooseUs;
